<template>
  <div id="divContainer" v-on:click="exitmenu" class="body-content-info">
    <!-- 
       v-bind:style="{ backgroundImage: 'url(' + bgImage + ')' }"
    style="
      background-image: url('https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FHelpDesk_1160x600.png?alt=media');
    " -->

    <!-- <TopMenu /> -->
    <div class="help-des-wrapper" @click="onClickHandler">
      <div class="help-des-img-desktop">
        <div class="hs-area">
          <!-- <img :src="expomainurl" data-imgdim="900,500" width="80%" /> -->

          <div class="hs-wrap">
            <div
              class="shadow-spot"
              data-coord="361.984,331"
              data-dim="47,42,0"
              data-activeon="hover"
            ></div>
            <div class="tt-wrap">
              <div class="tip-tooltip white" data-anim="goin" data-dir="top">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/4jYv2UvYsjg"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="hs-wrap">
            <div
              class="shadow-spot"
              data-coord="421.984,332"
              data-dim="43,42,0"
              data-activeon="hover"
            ></div>
            <div class="tt-wrap">
              <div class="tip-tooltip white" data-anim="goin" data-dir="top">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/A2TNpe3NtMw"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="hs-wrap">
            <div
              class="shadow-spot"
              data-coord="474.984,332"
              data-dim="44,43,0"
              data-activeon="hover"
            ></div>
            <div class="tt-wrap">
              <div class="tip-tooltip white" data-anim="goin" data-dir="top">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/k4EbH9ynITo"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="hs-wrap">
            <div
              class="shadow-spot"
              data-coord="528,333"
              data-dim="42,44,0"
              data-activeon="hover"
            ></div>
            <div class="tt-wrap">
              <div class="tip-tooltip white" data-anim="goin" data-dir="top">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/j7UsYOWdgUo"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="hs-wrap">
            <div
              class="shadow-spot"
              data-coord="580.984,333"
              data-dim="41,44,0"
              data-activeon="hover"
            ></div>
            <div class="tt-wrap">
              <div class="tip-tooltip white" data-anim="goin" data-dir="top">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/4z5Y-pY_DtY"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="help-info-desc row mt-4" id="DivChat">
        <div class="col-12">
          <p>
            <img
              :src="eventLogoUrl"
              data-imgdim="200,50"
              width="400px"
              class="info-event-logo"
            />
            For Live Chat Support
            <button
              id="btnOpenChat"
              type="button"
              class="reg-button text-uppercase ml-5 btn-open-chat mt-2 mt-md-0"
              @click="OpenChat"
            >
              Click Here
            </button>
          </p>
          <!--<span class="btn-contact">CONTACt US NOW!</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
//import TopMenu from "@/components/TopMenu.vue";
import analytics from "@/components/Analytics";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
var self;
export default {
  components: {
    //TopMenu
  },
  data() {
    return {
      bgImage:"",
      // InfoPageShowLiveHelpChatPanel: false,
    };
  },
  mounted() {
    $("#topmenu").show();
    $("#DivChat").hide();
    $("#divContainer").css("background-image", "url(" + self.bgImage + ")");
    //debugger;
    //if ($("#ulLeftMenu li").length > 0) {
    //  $("#leftMenuParent").show();
    //  $("#leftmenu").show();
    //} else {
    //  $("#leftMenuParent").hide();
    //  $("#leftmenu").hide();
    //}
    $("#btnAddUserView").click();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);

    $("#btnOpenChat").css(
      "background-color",
      obj.EventBranding[0].topBar + " !important"
    );
    $(".btn-open-chat").css(
      "background-color",
      obj.EventBranding[0].topBar + " !important"
    );
    $(".btn-open-chat").css(
      "color",
      obj.EventBranding[0].fontBar + " !important"
    );

    //$("#divContainer").css(
    //  "background-image",
    //  "url(" + obj.EventBranding[0].eventBGImage + ")"
    //);
    //$("#divContainer").css(
    //  "background-image",
    //  "url('https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1597757246851E1597758557223%2FBranding%2F2732x2048.jpg?alt=media&token=d36b5b71-ef12-4025-a7cc-211f260138fb')"
    //);
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      // "src",
      // "https://ajax.googleapis.com/ajax/libs/jquery/1.8.3/jquery.min.js"
      "src",
      "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
    );
    externalScript.setAttribute("type", "text/javascript");
    document.body.appendChild(externalScript);

    let externalScript1 = document.createElement("script");
    externalScript1.setAttribute(
      // "type",
      // "https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/jquery-ui.min.js"

      "type",
      "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
    );
    externalScript1.setAttribute("type", "text/javascript");
    document.body.appendChild(externalScript1);

    let externalScript3 = document.createElement("script");
    externalScript3.setAttribute(
      "src",
      "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.js?alt=media"
    );
    externalScript3.setAttribute("type", "text/javascript");
    document.body.appendChild(externalScript3);

    let externalScript4 = document.createElement("script");
    externalScript4.setAttribute(
      "src",
      "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.min.js?alt=media"
    );
    externalScript4.setAttribute("type", "text/javascript");
    document.body.appendChild(externalScript4);

    let externalScript5 = document.createElement("script");
    externalScript5.setAttribute(
      "src",
      "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fother.js?alt=media"
    );
    externalScript5.setAttribute("type", "text/javascript");
    document.body.appendChild(externalScript5);
    self.setBg();
  },
  created() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#btnOpenChat").css(
      "background-color",
      obj.EventBranding[0].topBar + " !important"
    );
    $(".btn-open-chat").css(
      "background-color",
      obj.EventBranding[0].topBar + " !important"
    );
    $(".btn-open-chat").css(
      "color",
      obj.EventBranding[0].fontBar + " !important"
    );
  },
  methods: {
    setBg() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("EventInfo")
        .get()
        .then((doc) => {
          if (doc.exists) {
            var docs = doc.data();
            console.log(docs.Plugins);

            if (docs.Plugins.InfoDesk) {
              if (docs.Plugins.InfoDesk.InfoPageBackgroundImage != undefined) {
                if (docs.Plugins.InfoDesk.InfoPageBackgroundImage != "") {
                  debugger;

                  self.bgImage = docs.Plugins.InfoDesk.InfoPageBackgroundImage;
                  debugger;
                  $("#divContainer").css(
                    "background-image",
                    "url(" + docs.Plugins.InfoDesk.InfoPageBackgroundImage + ")"
                  );
                } else {
                  $("#divContainer").css(
                    "background-image",
                    "url(" + 'https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2Fhelpdesk-bg.jpg?alt=media&token=ba1e158c-92e4-4d1c-a58b-1a44a46f47d9' + ")"
                  );
                }
              } else {
                $("#divContainer").css(
                  "background-image",
                  "url(" + 'https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2Fhelpdesk-bg.jpg?alt=media&token=ba1e158c-92e4-4d1c-a58b-1a44a46f47d9' + ")"
                );
              }

              if (docs.Plugins.InfoDesk.InfoPageShowLiveHelpChatPanel) {
                $("#DivChat").show();
              }

              // self.InfoPageShowLiveHelpChatPanel =
              //   docs.Plugins.InfoDesk.InfoPageShowLiveHelpChatPanel == undefined
              //     ? false
              //     : docs.Plugins.InfoDesk.InfoPageShowLiveHelpChatPanel;
            }else{
                  $("#divContainer").css(
                    "background-image",
                    "url(" + 'https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2Fhelpdesk-bg.jpg?alt=media&token=ba1e158c-92e4-4d1c-a58b-1a44a46f47d9' + ")"
                  );
            }

            //           self.embededIframe =
            //             doc.data().SocialWall
            //  != undefined
            //               ? doc.data().embededIframe
            //               : true;
          }
          console.log("embededIframe - " + self.embededIframe);
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
          //alert(error);
        });
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    OpenChat() {
      //alert("");
      //$("#tawkchat-status-text-container").click();
      //$("#maximizeChat").click();
      //$("#maximizeChat").trigger("click");
      //$("#tawkchat-status-text-container").trigger("click");
      //window.Tawk_API.toggleVisibility();
      if (window.Tawk_API) {
        window.Tawk_API.maximize();
      }
    },
  },
  computed: {
    eventLogoUrl() {
      let url = "";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      url = obj.EventBranding[0].eventLogo;

      return url;
    },
    expomainurl() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname == "OA_UAT_C1591904892446E1591907102804") {
        return "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FHelpdesk%20Booth%2Fhelpdesc.png?alt=media";
      } else if (
        obj.eventcollectionname == "OA_UAT_C1591205467009E1594731602730"
      ) {
        return "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591205467009E1594731602730%2FHelpdesk%20Booth%2Fhelpdesc.png?alt=media";
      } else {
        if (location.host.toLowerCase().startsWith("uat") >= 0) {
          return "https://resources.e2m.live/uate2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FHelpDesk_1160x600.png?alt=media";
        } else {
          return "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FHelpDesk_1160x600.png?alt=media";
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/Hotspot/css/jquery-hotspotter.min.css";
@import "../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";

.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}

.help-des-wrapper {
  width: 100%;
}
.glass-spot {
  box-shadow: 1px 4px 20px #3d3c3c;
}
.help-des-img-desktop {
  width: 900px;
  margin: 10px auto 0;
  min-height: 350px;
}
.body-content-info {
  min-height: calc(100vh - 115px);
  background-size: cover;
  background-position: center center;
}
.help-info-desc {
  text-align: center;
  background-color: #fff;
  width: 900px;
  margin: 0 auto;
  padding: 10px 0;
  box-shadow: 0 1px 10px 0px #1c1c1c38;
  //box-shadow: 0 1px 6px 0 rgba(28, 28, 28, 10%);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  top: auto;
}
.help-info-desc p {
  font-weight: bold;
}
.info-event-logo {
  margin-right: 50px;
}
.body-content-info .hs-area {
  text-align: center;
}
.btn-open-chat {
  background-color: #000;
  color: #fff;
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
  .help-info-desc{width: 100%}
  .help-des-img-desktop{ width: 100%;}
  .help-info-desc p {height: 50px;width: 200px;}
  .help-info-desc p {height: 50px;width: 100%; display: flex; justify-content: space-between; align-items: center;}
  .help-info-desc p img.info-event-logo {width: 200px;}
}
</style>
